import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
`;

export const ChooseBox = styled.div`
  width: 100%;
`;

export const Header = styled.header`
  display: ${({ dontShowHeader }) => (dontShowHeader ? 'none' : 'flex')};
  align-items: center;
  justify-content: space-between;
  background: transparent;
  padding: 4px 24px;
  width: 100%;
`;

const setVisibility = ({ visible }) => (visible ? 'visible' : 'hidden');

export const CollapseAll = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${() => Palette.Primary._500};
  visibility: ${setVisibility};
  cursor: pointer;
`;

export const LinkAction = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  visibility: ${setVisibility};
  :hover {
    ${({ disabled }) =>
      !disabled &&
      css`
        text-decoration: underline;
        text-decoration-color: ${Palette.Primary._500};
      `}
  }
  :active {
    ${({ disabled }) =>
      !disabled &&
      css`
        color: ${() => Palette.Primary._600};
      `}
  }
  ${({ disabled }) =>
    disabled
      ? css`
          color: ${Palette.PrimaryGray._400};
          text-decoration-color: inherit;
          cursor: not-allowed;
        `
      : css`
          color: ${Palette.Primary._500};
        `};
`;

export const SearchIconWrapper = styled.div`
  display: inline-flex;

  ${({ isFocusable }) =>
    isFocusable &&
    css`
      border-bottom-color: ${() => Palette.Primary._300};
    `}
  svg {
    fill: ${({ isFocusable }) => (isFocusable ? Palette.Primary._400 : Palette.PrimaryGray._400)};
  }
`;

export const SearchInputWrapper = styled.div`
  width: 100%;
  position: relative;
  ${SearchIconWrapper} {
    position: absolute;
    color: blue;
    left: 25px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const ContainerForScroll = styled.div`
  /* padding-right: 4px; */
  border-bottom: 1px solid ${() => Palette.PrimaryGray._200};
`;

export const ChooseMain = styled.div`
  height: 388px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${() => Palette.PrimaryGray._300};
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: ${Palette.PrimaryGray._000};
  }
`;

export const ClearSearchInputWrapper = styled.div`
  visibility: ${({ visible }) => (!visible ? 'hidden' : 'visible')};
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 4px;
  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    fill: ${() => Palette.PrimaryGray._400};
  }
  &:hover {
    svg {
      fill: ${() => Palette.PrimaryGray._500};
    }
    background: ${() => Palette.PrimaryGray._100};
  }
  &:active {
    svg {
      fill: ${() => Palette.Primary._500};
    }
    background: ${() => Palette.Primary._000};
  }
`;

export const SearchInput = styled.input`
  color: ${() => Palette.PrimaryGray._900};
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  border-top: ${({ oneSection }) => oneSection && 'none'};
  height: 48px;
  background: #fff;
  padding: 6px 48px;
  width: 100%;
  margin-bottom: 0;

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${() => Palette.PrimaryGray._400};
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }
`;
